import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (sessionStorage.getItem('token') != null) {
      const redirectUrl = route.queryParamMap.get('redirect');
      if(redirectUrl){
        this.router.navigate([redirectUrl]);
        return false;
      }

      this.router.navigate(['home']);
      return false;
    }

    const segments = state.url.split('/').filter((segment) => segment);

    if (
      segments.length >= 1 &&
      (segments[0].includes('login(') ||
        segments[0].includes('register(') ||
        segments[0].includes('authentication-management(') ||
        segments[0].includes('finish('))
    ) {
      const additionalParams = segments[0].split('(');
      window.location.href = '/' + additionalParams[0];
      return false;
    }
    return true;
  }
}
